import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import { paths } from 'src/routes/paths';

import DashboardLayout from 'src/layouts/dashboard';
import { FeatureFlag } from 'src/auth/feature-flags';
import { AuthGuard, OnboardingGuard } from 'src/auth/guard';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/SupportTicketIndexPage'));
const ViewPage = lazy(() => import('../pages/SupportTicketViewPage'));

// ----------------------------------------------------------------------

export const supportTicketRoutes = [
  {
    path: paths.support.tickets.index,
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <FeatureFlagGuard flag={FeatureFlag.SupportTicket}>
            <DashboardLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </DashboardLayout>
          </FeatureFlagGuard>
        </OnboardingGuard>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: ':id', element: <ViewPage /> },
    ],
  },
];
